import React from 'react';
import { ISendGridEvent } from '../../generated/graphql';
import { Colors } from '../../utils/theme';
import { Grid } from '@mui/material';
import moment from 'moment';

interface IProps {
  event: ISendGridEvent;
}

const EventDetail: React.FunctionComponent<IProps> = ({ event }: IProps) => {
  const getStatusColor = (status: string): string => {
    if (status === 'processed') {
      return Colors.warning;
    } else if (status === 'spam_report') {
      return Colors.red;
    } else {
      return Colors.green;
    }
  };

  return (
    <Grid
      container
      style={{
        marginTop: '2px',
        height: '40px',
        background: Colors.lightBlue,
        marginBottom: '4px',
        width: '99%'
      }}
      className={'event-details-container'}
    >
      <Grid
        item
        xs={3}
        style={{
          fontSize: '14px',
          fontFamily: 'Overpass',
          fontWeight: 'bold',
          color: Colors.dark_gray,
          paddingLeft: '2.83%',
          paddingTop: '12px'
        }}
      >
        {moment(parseInt(event.timestamp as string, 10)).format('yyyy-MM-DD HH:mm:ss')}
      </Grid>
      <Grid
        item
        xs={2}
        style={{
          fontSize: '14px',
          fontFamily: 'Overpass',
          fontWeight: 'bold',
          color: getStatusColor(event.name as string),
          paddingTop: '12px',
          textAlign: 'center'
        }}
      >
        {event.name}
      </Grid>
      <Grid item xs={7} style={{ textAlign: 'right', paddingRight: '2%', marginTop: 'auto' }}>
        {event.url && (
          <a target="_blank" rel="noreferrer" href={event.url} style={{ color: Colors.main }}>
            {event.url}
          </a>
        )}
      </Grid>
    </Grid>
  );
};

export default EventDetail;
